import * as React from 'react';

import FolderExternal32 from './FolderExternal32';

export const folderExternal32 = () => <FolderExternal32 />;

export default {
    title: 'Icon|Content|FolderExternal32',
    component: FolderExternal32,
    parameters: {
        notes: "`import FolderExternal32 from 'box-ui-elements/es/icon/content/FolderExternal32';`",
    },
};
